<template>
    <div class="edit-employee">
        <form-component ref="form" class="edit-employee-page container" v-if="!employeeSaved">
            <div class="row">
                <div class="col">
                    <div class="box">
                        <h4>Gegevens Zorg Professional</h4>
                        <input-component
                                label="Naam"
                                v-model="emplopyeeToEdit.userName"
                                :disabled="true">
                        </input-component>
                        <input-component
                                label="Email"
                                v-model="emplopyeeToEdit.email"
                                :disabled="true">
                        </input-component>
                        <input-component
                                type="text"
                                label="Telefoonnummer"
                                v-model="emplopyeeToEdit.phoneNumber"
                                :disabled="true">
                        </input-component>
                            <label for="location">Woonlocatie</label>
                            <select id="location"
                                    class="form-control"
                                    v-model="emplopyeeToEdit.location">
                                <option value=""></option>
                                <option v-for="location in getAllLocations" :value="location" :key="location.id">
                                    {{ location.locationName }}
                                </option>
                            </select>

                    </div>
                </div>
            </div>
            <button-component @click.native="updateEmployee">
                Opslaan
            </button-component>
        </form-component>

        <div class="employee-created" v-if="employeeSaved">
            <div class="complete-image"></div>
            <p class="complete-title">Zorg Professional {{ emplopyeeToEdit.email }} gewijzigd, u wordt teruggestuurd naar het overzicht</p>
            <circle-component position="bottom-center" height=236 />
        </div>
    </div>
</template>

<script>
import { RouteName } from '../../utils/enums';
import ButtonComponent from '../../components/button.component.vue';
import FormComponent from '../../components/fields/form.component.vue';
import InputComponent from '../../components/fields/input.component.vue';
import CircleComponent from '@/components/circle.component.vue';
import { mapGetters } from "vuex";
import { Employee } from "../../domain/employee";

export default {
    name: 'admin-edit-employee-page',
    components: {
        FormComponent,
        InputComponent,
        ButtonComponent,
        CircleComponent
    },
    data() {
        return {
            loaded: false,
            emplopyeeToEdit: Employee,
            employeeSaved: false,
            buttonDisabled: false,
            locations: []
        };
    },
    computed: {
        ...mapGetters(['getAllLocations']),
    },
    mounted() {
        this.locations = this.$store.getters.getAllLocations;
        this.emplopyeeToEdit = this.$store.getters.getEmployeeToEdit;
    },
    methods: {
        updateEmployee() {
            if (this.emplopyeeToEdit.location === '') this.emplopyeeToEdit.location = null;
            if (!this.buttonDisabled) {
                this.buttonDisabled = true; // disable after first click, to prevent multiple clients are saved
                this.$store.dispatch('UPDATE_EMPLOYEE', this.emplopyeeToEdit)
                    .then(response => {
                        if (response.status === 200) { // updated, show confirmation
                            this.employeeSaved = true; // redirect back after 2 seconds
                            setTimeout(() => {
                                this.$router.push({name: RouteName.ADMIN_EMPLOYEES});
                            }, 2500);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    })
            }
        }
    }
};
</script>

<style scoped lang="scss">
    .row {
        flex-direction: column;

        @include desktop {
            flex-direction: row;
        }
    }

    .box {
        margin-bottom: 2rem;

        @include desktop {
            background-color: $white;
            // height: 100%;
            padding: 1rem;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
        }

        h4 {
            font-weight: 400;
            margin-bottom: 1rem;
            color: $gray-darkest;
        }
        .errorMessage {
            color: $error;
            font-size: 12px;
            font-weight: normal;
        }

        .deleteButton {
            color: red;
            font-weight: bold;
            margin-bottom: 0px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .add-contacts {
        border-radius: 4px;
        border: 1px solid $gray;
        padding: 1rem;
        position: relative;
        margin-bottom: 1rem;

        .add-button {
            $button-size: 42px;
            position: absolute;
            bottom: -($button-size / 2);
            left: 50%;
            margin-left: -($button-size / 2);
            width: $button-size;
            height: $button-size;
            border-radius: 50%;
            background-color: $primary;
            color: $white;
            font-weight: bold;

            &:hover {
                background-color: $lightGreen;
            }
        }
    }

    .subtitle {
        margin: 1rem 0;
        display: block;
        font-weight: 500;
    }

    .seperator {
        margin: 2rem 0;
        background-color: $gray;
    }

    .input-component,
    .switch-component {
        margin-bottom: 1rem;
    }

    .row-wrapper {
        display: flex;

        .input-component {
            flex-grow: 1;

            &:first-child {
                margin-right: 60px;
            }
        }
    }

    .smartwatch-bg-color {
        margin-bottom: 1rem;
    }
    .employee-created {
        height: 100%;
        background-color: $primary;
        color: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .complete-title {
            margin-bottom: 14px;
        }

        p {
            font-size: 16px;
            text-align: center;
        }
    }

    .complete-image {
        width: 95px;
        height: 120px;
        background-image: url('../../assets/icons/watch-large-complete.svg');
        margin-bottom: 64px;
        margin-top: -60px;
    }
    select {
        width: 100%;
        border: 1px solid $gray;
        border-radius: 3px;
        height: 52px;
        padding: 1rem;

        &:hover {
            cursor: pointer;
        }
    }
</style>
